import e from "@dialpad/dialtone-tokens/layered/themes/tokens-116-colors.css?inline";
//#region themes/116.js
var t = { brand: {
	css: e,
	name: "116"
} };
//#endregion
export { t as default };
